module.exports = __webpack_public_path__ + "static/media/x-circle-light.4be50b05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/x-circle-light.svg
// module id = 1772
// module chunks = 50